import { withErrorBoundary } from 'react-error-boundary';
import type { ContentfulArticleModel } from 'autogen/swagger/all';
import ArticleCardItem from './ArticleCardItem';

function ArticleCardList({ articles, ...restProps }: { articles: ContentfulArticleModel[] }) {
    return articles.map((article, index) => {
        return <ArticleCardItem key={article.link?.url || index} article={article} {...restProps} />;
    });
}

export default withErrorBoundary(ArticleCardList, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
